import React from 'react';
import { Card, CardContent } from './ui/card';
import { toolsData } from '../data/mockData';
import { Sparkles } from 'lucide-react';

const Tools = () => {
  return (
    <section id="tools" className="py-20 bg-slate-50">
      <div className="max-w-6xl mx-auto px-6">
        {/* Section Header */}
        <div className="text-center mb-12">
          <div className="flex items-center justify-center gap-2 mb-4">
            <Sparkles className="h-6 w-6 text-blue-600" />
            <h2 className="text-3xl md:text-4xl font-bold text-slate-900">
              {toolsData.sectionTitle}
            </h2>
          </div>
          <p className="text-lg text-slate-600 max-w-2xl mx-auto">
            {toolsData.description}
          </p>
        </div>

        {/* Tools Grid */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
          {toolsData.tools.map((tool, index) => (
            <Card
              key={index}
              className="group border-slate-200 hover:border-blue-400 hover:shadow-lg transition-all duration-300 hover:-translate-y-1"
            >
              <CardContent className="p-8 text-center">
                <div className="w-16 h-16 mx-auto mb-4 rounded-full bg-blue-600 flex items-center justify-center text-white text-2xl font-bold group-hover:scale-110 transition-transform duration-300">
                  {tool.name.charAt(0)}
                </div>
                <h3 className="text-lg font-bold text-slate-900">
                  {tool.name}
                </h3>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Tools;
